export const initCasesGalleries = () => {
    const sliders = document.querySelectorAll(".js-cases-inner-swiper");
    if (!sliders) return;
    sliders.forEach((slider, index) => {
        const links = slider.querySelectorAll("[data-fancybox]");

        const groupName = `case-gallery-${index}`;

        links.forEach(link => {
            link.setAttribute("data-fancybox", groupName);
        });
    });
};
